import { lazy } from 'react';
import { type RouteObject } from 'react-router';

import { dashboardRoutes } from './Dashboard';

const ForbiddenPage = lazy(() => import('src/pages/error/ForbiddenPage'));
const NotFoundPage = lazy(() => import('src/pages/error/NotFoundPage'));

export const routesSection: RouteObject[] = [
  ...dashboardRoutes,
  {
    path: '/403',
    element: <ForbiddenPage />,
  },
  { path: '*', element: <NotFoundPage /> },
];
